<template>
  <div class="container mb-4">
    <div class="row mt-4">
      <div class="col">
        <ul class="nav nav-tabs">
          <li class="nav-item">
            <router-link to="/prediction/bodytype" :class="`nav-link ${active == 'bodytype' ? 'active' : ''}`">
              By Body Type
            </router-link>
          </li>
          <li class="nav-item">
            <router-link to="/prediction/fueltype" :class="`nav-link ${active == 'fueltype' ? 'active' : ''}`">
              By Fuel Type
            </router-link>
          </li>
          <li class="nav-item">
            <router-link to="/prediction/trim" :class="`nav-link ${active == 'trim' ? 'active' : ''}`">
              By Trim
            </router-link>
          </li>
          <li class="nav-item">
            <router-link to="/prediction/year" :class="`nav-link ${active == 'year' ? 'active' : ''}`">
              By Year
            </router-link>
          </li>
          <li class="nav-item">
            <router-link to="/prediction/mileage" :class="`nav-link ${active == 'mileage' ? 'active' : ''}`">
              By Mileage
            </router-link>
          </li>
        </ul> 
        <div class="tab-content">
          <p>You have to select ALL parameters for price prediction.</p>
          <router-view />
        </div>
      </div>
    </div>
    
  </div>
</template>

<script>

export default {
  computed: {
    active() {
      return this.$route.name;
    }
    
  }
};
</script>
